import { createSelector } from 'reselect';
import { createSelector as repackagedCreateSelector } from '../../types/createSelector';
import StateStatusGroups from 'ContentUtils/constants/StateStatusGroups';
import { getFullCategory } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { STATE_KEYS } from 'ContentEditorUI/lib/publishing/constants';
import I18n from 'I18n';
// @ts-expect-error not yet migrated
import { createUnmemoizedSelector } from 'ContentEditorUI/redux/selectors/unmemoizedSelectorCreator';
import { getIsFormValid } from 'ContentEditorUI/redux/selectors/formStatusSelectors';
import { getIsSaveInProgress, getIsSavePermanentlyDisabled } from 'ContentEditorUI/redux/selectors/saveDataSelectors';
import { getHasAnyModulesWithErrors } from 'ContentEditorUI/redux/selectors/moduleErrorSelectors';
// @ts-expect-error not yet migrated
import * as SimpleDate from 'UIComponents/core/SimpleDate';
import { getContentState, getSubcategory, getPublishDate, getShouldPublishImmediately } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { isScheduledState, isPublishedState, isErrorState
// @ts-expect-error not yet migrated
} from 'ContentEditorUI/utils/publishUtils';
import { getContentPublishRequest } from 'ContentEditorUI/redux/selectors/requestStatesSelectors';
import { requestStarted, requestFailed } from 'redux-request-state/util/requestStateCheckers';
import { getHardSavedContentModelIsPublishedNotScheduled, getHardSavedContentModelIsScheduled, getHardSavedContentModelScheduledUpdateDate } from './hardSavedContentModelSelectors';
export const getIsPublished = createSelector([getContentState], state => isPublishedState(state));
export const getIsScheduled = createSelector([getContentState], state => isScheduledState(state));
export const getIsErrored = createSelector([getContentState], state => isErrorState(state));
export const getIsDraft = createSelector([getContentState], state => StateStatusGroups.DRAFT.includes(state));
export const getIsSuggested = createSelector([getContentState], state => StateStatusGroups.SUGGESTED.includes(state));
export const getIsAutomated = createSelector([getContentState], state => state && (state === 'AUTOMATED' || state.startsWith('AUTOMATED_')));
export const getPublishDateDay = createSelector([getPublishDate], publishDate => {
  return publishDate ?
  // @ts-expect-error Property 'portalTz' does not exist on type 'Moment'.
  SimpleDate.fromMoment(I18n.moment(publishDate).portalTz()) : null;
});
export const getPublishDateTime = createSelector([getPublishDate], publishDate => {
  // @ts-expect-error Property 'portalTz' does not exist on type 'Moment'.
  const portalTz = I18n.moment(publishDate).portalTz();
  return publishDate ? portalTz.hours() * 60 + portalTz.minutes() : null;
});
export const getIsAfterScheduledPublishDate = createUnmemoizedSelector([getPublishDate], publishDate => publishDate < I18n.moment.portalTz().valueOf());

/** @deprecated Not being used anywhere */
export const getPublishType = createSelector([getIsPublished, getShouldPublishImmediately, getIsAfterScheduledPublishDate], (isPublished, shouldPublishImmediately, isAfterScheduledPublishDate) => {
  if (isPublished && (isAfterScheduledPublishDate || shouldPublishImmediately)) {
    return 'update';
  } else if (shouldPublishImmediately) {
    return 'publish';
  }
  return 'schedule';
});

// TODO: possibly replace this to use the CMP object for easier derivation of publish type from `hs_resolved_state`
/** @deprecated use `useContentCrmObject` hook to get the publish type from content crm object */
export const getUnifiedPublishType = createSelector([getHardSavedContentModelIsPublishedNotScheduled, getHardSavedContentModelIsScheduled, getHardSavedContentModelScheduledUpdateDate], (isPublished, isScheduled, scheduledUpdateDate) => {
  if (isScheduled || !!scheduledUpdateDate) {
    return 'schedule';
  }
  if (isPublished) {
    return 'update';
  }
  return 'publish';
});
export const getIsPublishingNotUpdating = createSelector([getIsPublished, getShouldPublishImmediately], (isPublished, shouldPublishImmediately) => !isPublished && shouldPublishImmediately);
export const getIsSchedulingNotUpdating = createSelector([getIsPublished, getShouldPublishImmediately, getIsScheduled], (isPublished, shouldPublishImmediately, isScheduled) => !isPublished && !shouldPublishImmediately && !isScheduled);
export const getIsSchedulingAlreadyPublished = createSelector([getIsPublished, getIsDraft, getShouldPublishImmediately], (isPublished, isDraft, shouldPublishImmediately) => {
  return !shouldPublishImmediately && !isDraft && isPublished;
});
export const getPublishStateKey = createSelector([getIsPublished, getIsScheduled], (isPublished, isScheduled) => {
  if (isPublished) {
    return STATE_KEYS.PUBLISHED;
  } else if (isScheduled) {
    return STATE_KEYS.SCHEDULED;
  }
  return STATE_KEYS.DRAFT;
});
export const getPublishNoun = createSelector([getFullCategory, getSubcategory], (fullCategory, subcategory) => {
  let categoryKey = fullCategory.field_name.toLowerCase();
  if (['site_page', 'optin-email'].includes(subcategory)) {
    categoryKey = subcategory;
  }
  return `categories.${categoryKey}`;
});

// AND with app-specific conditions and permission/scope checks
export const getIsPublishEnabledBase = repackagedCreateSelector([getIsFormValid, getIsSaveInProgress, getIsSavePermanentlyDisabled, getHasAnyModulesWithErrors], (isFormValid, isSaveInProgress, isSavePermanentlyDisabled, hasAnyModulesWithErrors) => Boolean(isFormValid && !isSaveInProgress && !isSavePermanentlyDisabled && !hasAnyModulesWithErrors));
export const getUnpublishWarningLangKey = createSelector([getIsDraft], isDraft => {
  return isDraft ? STATE_KEYS.DRAFT : STATE_KEYS.PUBLISHED;
});
export const getIsPublishInProgress = createSelector([getContentPublishRequest], contentPublishRequest => requestStarted(contentPublishRequest));
export const getIsPublishFailed = createSelector([getContentPublishRequest], contentPublishRequest => requestFailed(contentPublishRequest));